import {ListItem, ListItemText} from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';
import type {Species} from '@/domain/entities/Species';

type Props = {
  species: Species[];
};

const SpeciesLegend: FC<Props> = ({species}) => {
  return (
    <Stack direction="row" sx={{flexWrap: 'wrap'}}>
      {species.map((specie) => (
        <Stack direction="row" key={specie.xorforId}>
          <ListItem sx={{m: 0, p: 0}}>
            <Box sx={styles.swatchContainer}>
              <Box
                sx={{
                  bgcolor: specie.color,
                  ...styles.swatch,
                }}
              />
            </Box>
            <ListItemText sx={{m: 0, p: 0}}>
              <Typography variant="caption" sx={styles.label}>
                {specie.nameKey}
              </Typography>
            </ListItemText>
          </ListItem>
        </Stack>
      ))}
    </Stack>
  );
};

export default SpeciesLegend;

const styles: Record<string, SxProps> = {
  swatchContainer: {
    margin: '8px 0px 0px 0px',
    padding: 0,
    width: '40px',
    height: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  swatch: {
    height: '10px',
    width: '10px',
    borderRadius: '50%',
    mb: 1,
    border: '1px solid black',
  },
  label: {
    color: 'grey.700',
    textTransform: 'capitalize',
  },
};
